import { RDSnackBarService } from './snack-bar.service';
import { Component, OnInit, Input } from '@angular/core';
import { RDSnackBar } from './snack-bar.class';
import { trigger, transition, query, stagger, animate, keyframes, style } from '@angular/animations';

@Component({
  selector: 'rd-snack-bar',
  template: `<div class="snackbarContainer" [@listAnimation]="snackBars.length">
  <div *ngFor="let snackBar of snackBars; let i = index" class="snackBar {{snackBar.snack.type}}SnackBar" (click)="closeSnackBar(i)">
    <span class="closeIcon"><i class="fas fa-times"></i></span>
    <div class="headerSnackBar">
      <span><i class="{{getIcon(snackBar.snack.type)}}"></i></span>
      {{ snackBar.snack.title }}
    </div>
    <div class="textSnackBar">
      {{snackBar.snack.text}}
    </div>
  </div>
</div>
`,
  styles: [`.snackbarContainer{position:fixed;bottom:5%;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%);width:50%;display:flex;flex-direction:column-reverse;z-index:1000}.snackbarContainer .snackBar{position:relative;cursor:pointer;width:100%;padding:6px;margin:6px 0;color:#fff;transition:all .3s ease-in-out}.snackbarContainer .snackBar .closeIcon{position:absolute;top:6px;right:6px}.snackbarContainer .snackBar .headerSnackBar{width:85%}.snackbarContainer .snackBar .headerSnackBar,.snackbarContainer .snackBar .textSnackBar{word-break:break-all}.snackbarContainer .snackBar.dangerSnackBar{background-color:#ba5a5a}.snackbarContainer .snackBar.warningSnackBar{background-color:#baba5a}.snackbarContainer .snackBar.successSnackBar{background-color:#72ba5a}.snackbarContainer .snackBar.infoSnackBar{background-color:#5a5aba}@media (max-width:650px){.snackbarContainer{width:50%;min-width:250px}}`],
  animations: [
    trigger('listAnimation', [
      transition('* => *', [
        query(':enter', stagger('300ms', [
          animate('.5s ease-in', keyframes([
            style({opacity: 0.2, transform: 'translateY(-100%)', offset: 0}),
            style({opacity: 1, transform: 'translateY(0)', offset: 1.0}),
          ]))]), {optional: true}),
          query(':leave', stagger('300ms', [
            animate('.5s ease-in', keyframes([
              style({opacity: 1, offset: 0}),
              style({opacity: 0, transform: 'translateY(100%)', offset: 1.0}),
            ]))]), {optional: true})
      ])
    ])
  ]
})
export class RDSnackBarComponent implements OnInit {

  @Input() timer = 5;

  public snackBars: Array<{snack: RDSnackBar, timer: any}> = [];

  constructor(private snackBarService: RDSnackBarService) { }

  ngOnInit() {
    this.snackBarService.getSnackBar().subscribe(snackBar => {
      const newSnack = {snack: snackBar, timer: setTimeout(() => {
        this.deleteOnTimer(newSnack);
      }, this.timer * 1000)};
      this.snackBars.push(newSnack);
    });
  }

  deleteOnTimer(closeAlert) {
    for (let i = 0; i < this.snackBars.length; i++) {
      if (this.snackBars[i].timer === closeAlert.timer) {
        this.snackBars.splice(i, 1);
      }
    }
  }

  closeSnackBar(index) {
    clearTimeout(this.snackBars[index].timer);
    this.snackBars.splice(index, 1);
  }

  getIcon(type) {
    if (type === 'danger') {
      return 'fas fa-exclamation-triangle';
    } else if (type === 'warning') {
      return 'fas fa-exclamation';
    } else if (type === 'success') {
      return 'fas fa-check';
    } else if (type === 'info') {
      return 'fas fa-info';
    }
  }

}
